import { asset } from "../utils/asset";

export type StateOption = {
  label: string;
  value: string;
};

export const INDIAN_STATES: StateOption[] = [
  { label: "Andaman and Nicobar Islands", value: "AN" },
  { label: "Andhra Pradesh", value: "AP" },
  { label: "Arunachal Pradesh", value: "AR" },
  { label: "Assam", value: "AS" },
  { label: "Bihar", value: "BR" },
  { label: "Chandigarh", value: "CH" },
  { label: "Chhattisgarh", value: "CG" },
  { label: "Dadra and Nagar Haveli and Daman and Diu", value: "DN" },
  { label: "Delhi", value: "DL" },
  { label: "Goa", value: "GA" },
  { label: "Gujarat", value: "GJ" },
  { label: "Haryana", value: "HR" },
  { label: "Himachal Pradesh", value: "HP" },
  { label: "Jammu and Kashmir", value: "JK" },
  { label: "Jharkhand", value: "JH" },
  { label: "Karnataka", value: "KA" },
  { label: "Kerala", value: "KL" },
  { label: "Ladakh", value: "LA" },
  { label: "Lakshadweep", value: "LD" },
  { label: "Madhya Pradesh", value: "MP" },
  { label: "Maharashtra", value: "MH" },
  { label: "Manipur", value: "MN" },
  { label: "Meghalaya", value: "ML" },
  { label: "Mizoram", value: "MZ" },
  { label: "Nagaland", value: "NL" },
  { label: "Odisha", value: "OR" },
  { label: "Puducherry", value: "PY" },
  { label: "Punjab", value: "PB" },
  { label: "Rajasthan", value: "RJ" },
  { label: "Sikkim", value: "SK" },
  { label: "Tamil Nadu", value: "TN" },
  { label: "Telangana", value: "TG" },
  { label: "Tripura", value: "TR" },
  { label: "Uttar Pradesh", value: "UP" },
  { label: "Uttarakhand", value: "UT" },
  { label: "West Bengal", value: "WB" },
];

export const SPANISH_TOWNS_URL = asset("locations/es-towns.json");

export const SPANISH_PROVINCES: StateOption[] = [
  { label: "A Coruña", value: "A Coruña" },
  { label: "Albacete", value: "Albacete" },
  { label: "Alicante/Alacant", value: "Alicante/Alacant" },
  { label: "Almería", value: "Almería" },
  { label: "Araba/Álava", value: "Araba/Álava" },
  { label: "Asturias", value: "Asturias" },
  { label: "Ávila", value: "Ávila" },
  { label: "Badajoz", value: "Badajoz" },
  { label: "Barcelona", value: "Barcelona" },
  { label: "Bizkaia", value: "Bizkaia" },
  { label: "Burgos", value: "Burgos" },
  { label: "Cáceres", value: "Cáceres" },
  { label: "Cádiz", value: "Cádiz" },
  { label: "Cantabria", value: "Cantabria" },
  { label: "Castellón/Castelló", value: "Castellón/Castelló" },
  { label: "Ceuta", value: "Ceuta" },
  { label: "Ciudad Real", value: "Ciudad Real" },
  { label: "Córdoba", value: "Córdoba" },
  { label: "Cuenca", value: "Cuenca" },
  { label: "Gipuzkoa", value: "Gipuzkoa" },
  { label: "Girona", value: "Girona" },
  { label: "Granada", value: "Granada" },
  { label: "Guadalajara", value: "Guadalajara" },
  { label: "Huelva", value: "Huelva" },
  { label: "Huesca", value: "Huesca" },
  { label: "Illes Balears", value: "Illes Balears" },
  { label: "Jaén", value: "Jaén" },
  { label: "La Rioja", value: "La Rioja" },
  { label: "Las Palmas", value: "Las Palmas" },
  { label: "León", value: "León" },
  { label: "Lleida", value: "Lleida" },
  { label: "Lugo", value: "Lugo" },
  { label: "Madrid", value: "Madrid" },
  { label: "Málaga", value: "Málaga" },
  { label: "Melilla", value: "Melilla" },
  { label: "Murcia", value: "Murcia" },
  { label: "Navarra", value: "Navarra" },
  { label: "Ourense", value: "Ourense" },
  { label: "Palencia", value: "Palencia" },
  { label: "Pontevedra", value: "Pontevedra" },
  { label: "Salamanca", value: "Salamanca" },
  { label: "Santa Cruz de Tenerife", value: "Santa Cruz de Tenerife" },
  { label: "Segovia", value: "Segovia" },
  { label: "Sevilla", value: "Sevilla" },
  { label: "Soria", value: "Soria" },
  { label: "Tarragona", value: "Tarragona" },
  { label: "Teruel", value: "Teruel" },
  { label: "Toledo", value: "Toledo" },
  { label: "Valencia/València", value: "Valencia/València" },
  { label: "Valladolid", value: "Valladolid" },
  { label: "Zamora", value: "Zamora" },
  { label: "Zaragoza", value: "Zaragoza" },
];
